import axios, { AxiosResponse } from "axios";

export const requestInboundMail = async () => {
  const res = await axios.post("/company/request-inbound-mail");
  return res;
};

export const getCompanyInfo = async () => {
  const res = await axios.get("/company");
  return res;
};

export const getCompanies = async () => {
  const res = await axios.get("/company/list");
  return res;
};

export const updateCompanySip = async (payload: {
  domain: string;
  agent_id: string;
  front_desk_uri: string;
}) => {
  const res = await axios.patch("/company/sip", payload);
  return res;
};

export const updateCompanyChannels = async (
  payload: Partial<{
    call: boolean;
    sms: boolean;
    whatsapp: boolean;
    email: boolean;
  }>
) => {
  const res = await axios.patch("/company/channels", payload);
  return res;
};
